export enum PluginType {
  PLUGIN = 1,
  THEME = 2
}
